<template>
    <article>
     
      <span class="duplicata_sem_dt_venc" v-if="item.length == 0">Não Informada</span>
                <span class="duplicata_parcelada" v-if="item.length">
                  <v-tooltip top :close-delay="500" allow-overflow>
                    <v-chip
                          slot="activator"
                          small
                          color="grey darken-1"
                          text-color="white"
                          @click.native="openTabelaParcela(item)"
                          >
                        Produtos
                    </v-chip>
                    <span>Visualizar tabela de produtos</span>
                  </v-tooltip>  
        </span>
            <v-dialog @keydown.esc="openDialog = false" v-model="openDialog" scrollable max-width="750px">
              <v-card>
              <v-card-title>
                  <span><strong>Produtos</strong></span>
                  <v-spacer></v-spacer>
                  <v-btn icon dark   @click.native="openDialog=false">
                          <v-icon color="red">close</v-icon>
                  </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                  <v-container grid-list-md>
                  <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                      <table border="1" class="table_vencimento" >
                        <thead>
                          <tr>
                            <th colspan="8">Informações dos produtos</th>
                          </tr>
                          <tr>
                            <th colspan="1">Código</th>
                            <th colspan="1">Descrição</th>
                            <th colspan="1">NCM/SH</th>
                            <!-- <th colspan="1">O/CST</th> -->
                            <th colspan="1">CFOP</th>
                            <th colspan="1">UN</th>
                            <th colspan="1">Quantidade</th>
                            <th colspan="1">Valor Unitario</th>
                            <th colspan="1">Valor Total</th>
                            <!-- <th colspan="1">B.CÁLC ICMS</th>
                            <th colspan="1">VALOR ICMS</th>
                            <th colspan="1">VALOR IPI</th>
                            <th colspan="1">ALÍQ. ICMS </th>
                            <th colspan="1">ALÍQ. IPI </th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(duplicata,i) in item" :key="i">
                            <td class="text-xs-center">{{duplicata.cProd}}</td>
                            <td class="text-xs-center">{{duplicata.xProd}}</td>
                            <td class="text-xs-center">{{duplicata.NCM}}</td>
                            <!-- <td class="text-xs-center"></td> -->
                            <td class="text-xs-center">{{duplicata.CFOP}}</td>
                            <td class="text-xs-center">{{duplicata.uCom}}</td>
                            <td class="text-xs-center">{{duplicata.qCom}}</td>
                            <td class="text-xs-center valorReais">{{duplicata.vUnCom.toLocaleString("pt-BR", {minimumFractionDigits: 2,maximumFractionDigits: 2})}}</td>
                            <td class="text-xs-right valorReais">{{duplicata.vProd.toLocaleString("pt-BR", {minimumFractionDigits: 2,maximumFractionDigits: 2})}}</td>
                            <!-- <td class="text-xs-center"></td>
                            <td class="text-xs-center"></td>
                            <td class="text-xs-center"></td>
                            <td class="text-xs-center"></td>
                            <td class="text-xs-center"></td> -->
                          </tr>
                        </tbody>
                      </table>
                      </v-flex>
                  </v-layout>
                  </v-container>
              </v-card-text>
  
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click.stop="openDialog=false">Fechar</v-btn>
                  <!-- <v-btn color="success"  @click.stop="newColumn()">Criar</v-btn> -->
              </v-card-actions>
              </v-card>
          </v-dialog>
  
    </article>
  </template>
  <script>
  export default {
    props: ["item", "empresa", "component"],
    beforeMount() {},
    data: () => ({
      openDialog: false
    }),
    methods: {
      openTabelaParcela: function(item) {
        this.openDialog = true;
        console.log(item)
      }
    }
  };
  </script>
  <style>
  .duplicata_sem_dt_venc {
    color: red;
  }
  .table_vencimento {
    border-collapse: collapse;
    width: 100%;
  }
  .table_vencimento td,
  .table_vencimento th {
    border: 1px solid black;
  }
  .table_vencimento td {
    padding: 0px 60px;
  }
  .table_vencimento td.valorReais {
    position: relative;
  }
  .table_vencimento td.valorReais:before {
    content: "R$";
    left: 4px;
    position: absolute;
  }
  .duplicata_parcelada span.v-chip__content {
    cursor: pointer;
    font-size: 1.7em !important;
  }
  </style>
    
  


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_produtos/Coluna_produtos.vue